<template>
  <div class="main">
    <keep-alive>
      <data-warga v-if="$route.name === 'dashboard'"></data-warga>
    </keep-alive>
    <profile v-if="$route.name === 'profile'"></profile>
    <interactive-map v-if="$route.name === 'map'"></interactive-map>
    <surat-pemerintah v-if="$route.name === 'letter'"></surat-pemerintah>
    <new-account v-if="$route.name === 'new-account'"></new-account>
    <change-role v-if="$route.name === 'change-role'"></change-role>
    <surat-search v-if="$route.name === 'letter-search'"></surat-search>
  </div>
</template>

<script>
  import DataWarga from './data-warga/MainUI.vue'
  import Profile from './profile/MainUI.vue'
  import InteractiveMap from './map/MainUI.vue'
  import SuratPemerintah from './surat/mainUI.vue'
  import NewAccount from './new-account/MainUI.vue'
  import ChangeRole from './change-role/MainUI.vue'
  import SuratSearch from './surat-search/MainUI.vue'
  
  export default {
    components: {
      DataWarga,
      Profile,
      InteractiveMap,
      SuratPemerintah,
      NewAccount,
      ChangeRole,
      SuratSearch
    },
    created() {
      console.log(this.$route.name);
    }
  }
</script>

<style scoped>
  div {
    width: 100%;
  }
  
  .main {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: solid 5px #fff;
    height: calc(100% - 5px)
  }
  
</style>